
import React from "react";
import numeral from "numeral";
import { Grid } from "@material-ui/core";
import { HEDGE_TYPES, HEDGE_STATUSES } from "@loanbossinc/component-library";

import { StyledGridContainer, StyledLinkContainer, StyledLinkContainerRight, StyledFormikInputNumber, StyledFormikInputMoney, StyledFormikInputPercent,
  StyledFormikInputTypeAhead, StyledLinkTextFloatRight, StyledHedgeContainer, StyledHedgeContainerFooter,
  StyledHedgeHeader, StyledHedgeSubHeader, StyledFormikInputSwitch } from "./section.styles";

const ACTUAL_OVER_360 = "fb692b8f-766e-11e9-87b9-0242ac120002";
const CAP = "fc0fa822-733b-11e9-b768-0242ac120002";

const getNoHedgeRow = () => (<StyledHedgeContainer container>
  <StyledGridContainer item xs={12}><StyledHedgeSubHeader>There are no hedges</StyledHedgeSubHeader></StyledGridContainer>
                             </StyledHedgeContainer>
);

const getEmptyRow = (index, values, setValues, setFieldValue) => {
  const ratingsTriggers = values && values.ancillary && values.ancillary.ratingsTriggers ? values.ancillary.ratingsTriggers : [];
  const marketCost = values.hedges[index].marketCost;
  let marketCostFormatted = "";
  if (marketCost) {
    marketCostFormatted = numeral(marketCost).format("$0,0.00");
  }

  return (<>
    <StyledHedgeContainer container>
      <StyledGridContainer item xs={12}><StyledHedgeHeader>{marketCostFormatted}</StyledHedgeHeader></StyledGridContainer>
      <StyledGridContainer item xs={12}><StyledHedgeSubHeader>Save your changes to recalculate Market Cost</StyledHedgeSubHeader></StyledGridContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="requiredHedgeId"
          name={`hedges[${index}].hedgeTypeId`}
          label="Hedge Type"
          options={[
            { id: CAP, name: "Cap", label: "Cap", value: CAP },
            { id: "fe1fa999-733b-11e9-b768-0242ac120002", name: "Swap", label: "Swap", value: "fe1fa999-733b-11e9-b768-0242ac120002" }
          ]}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => handleRequiredHedgeChange(index, values, value, setFieldValue)}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>
    </StyledHedgeContainer>
    {getFooter(values, index, setValues)}
          </>
  );
};
const getCapRow = (index, values, setValues, setFieldValue) => {
  const ratingsTriggers = values && values.ancillary && values.ancillary.ratingsTriggers ? values.ancillary.ratingsTriggers : [];
  const marketCost = values.hedges[index].marketCost;
  let marketCostFormatted = "";
  if (marketCost) {
    marketCostFormatted = numeral(marketCost).format("$0,0.00");
  }

  return (<>
    <StyledHedgeContainer container>
      <StyledGridContainer item xs={12}><StyledHedgeHeader title="Market Cost">{marketCostFormatted}</StyledHedgeHeader></StyledGridContainer>
      <StyledGridContainer item xs={12}><StyledHedgeSubHeader>Save your changes to recalculate Market Cost</StyledHedgeSubHeader></StyledGridContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="requiredHedgeId"
          name={`hedges[${index}].hedgeTypeId`}
          label="Hedge Type"
          options={[
            { id: CAP, name: "Cap", label: "Cap", value: CAP },
            { id: "fe1fa999-733b-11e9-b768-0242ac120002", name: "Swap", label: "Swap", value: "fe1fa999-733b-11e9-b768-0242ac120002" }
          ]}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => handleRequiredHedgeChange(index, values, value, setFieldValue)}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer container item xs={12}>
        <Grid item xs={3}>
          <StyledFormikInputMoney
            name={`hedges[${index}].notional`}
            label={"Notional ($)"}
            variant={"filled"}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={3}>
          <StyledFormikInputPercent
            name={`hedges[${index}].strike`}
            label={"Strike (%)"}
            decimals={3}
            variant={"filled"}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={3}>
          <StyledFormikInputNumber
            name={`hedges[${index}].term`}
            label={"Term (months)"}
            variant={"filled"}
          />
        </Grid>
      </StyledGridContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="requiredHedgeId"
          name={`hedges[${index}].ratingsTriggerId`}
          label="Rating"
          options={ratingsTriggers}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => { }}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>

    </StyledHedgeContainer>
    {getFooter(values, index, setValues)}
          </>
  );
};
const handleRequiredHedgeChange = (index, values, value, setFieldValue) => {
  if (value && value === HEDGE_TYPES.SWAP) {
    setFieldValue(`hedges[${index}].notional`, values.details.amount);
    setFieldValue(`hedges[${index}].spread`, values.details.loanSpread);
    setFieldValue(`hedges[${index}].term`, values.details.loanTermMonths);
  } else if (value && value === HEDGE_TYPES.CAP) {
    setFieldValue(`hedges[${index}].notional`, values.details.amount);
    setFieldValue(`hedges[${index}].term`, values.details.loanTermMonths);
  }
};
const getSwapRow = (index, values, setValues, setFieldValue) => {
  const marketRate = values.hedges[index].marketRate;
  let marketRateFormatted = "";
  if (marketRate) {
    marketRateFormatted = numeral(marketRate).format("0.00%");
  }

  return (<>
    <StyledHedgeContainer container>
      <StyledGridContainer item xs={12}><StyledHedgeHeader title="Market Rate">{marketRateFormatted}</StyledHedgeHeader></StyledGridContainer>
      <StyledGridContainer item xs={12}><StyledHedgeSubHeader>Save your changes to recalculate Swap Rate</StyledHedgeSubHeader></StyledGridContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="requiredHedgeId"
          name={`hedges[${index}].hedgeTypeId`}
          label="Hedge Type"
          options={[
            { id: CAP, name: "Cap", label: "Cap", value: CAP },
            { id: "fe1fa999-733b-11e9-b768-0242ac120002", name: "Swap", label: "Swap", value: "fe1fa999-733b-11e9-b768-0242ac120002" }
          ]}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => handleRequiredHedgeChange(index, values, value, setFieldValue)}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer container item xs={12}>
        <Grid item xs={3}>
          <StyledFormikInputMoney
            name={`hedges[${index}].notional`}
            label={"Notional ($)"}
            variant={"filled"}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={3}>
          <StyledFormikInputPercent
            name={`hedges[${index}].spread`}
            label={"Spread (%)"}
            decimals={3}
            variant={"filled"}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={3}>
          <StyledFormikInputNumber
            name={`hedges[${index}].term`}
            label={"Term (months)"}
            variant={"filled"}
          />
        </Grid>
      </StyledGridContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputNumber
          name={`hedges[${index}].creditCharge`}
          label={"Credit Charge (bps)"}
          variant={"filled"}
        />
      </StyledGridContainer>

    </StyledHedgeContainer>
    {getFooter(values, index, setValues)}
          </>
  );
};
const getFooter = (values, index, setValues) => (<StyledHedgeContainerFooter container>
  <StyledLinkContainer item xs={5}>
    <StyledFormikInputSwitch
      name={`hedges[${index}].isPrefHedge`}
      label={"Preferred Hedge"}
      onClick={item => {
        setPreferredHedge(item.target, values, index, setValues);
      }}
    />
  </StyledLinkContainer>
  <StyledLinkContainerRight item xs={5}>
    <StyledLinkTextFloatRight
      onClick={() => {
        deleteHedge(values, index, setValues);
      }}
    >
      Remove Hedge
    </StyledLinkTextFloatRight>
  </StyledLinkContainerRight>
</StyledHedgeContainerFooter>);

const setPreferredHedge = (value, values, index, setValues) => {
  const hedge = values.hedges[index];
  const details = values.details;
  details.prefHedgeId = value.checked ? hedge.id : null;
  const hedges = values.hedges;
  for (let i = 0; i < hedges.length; i++) {
    hedges[i].isPrefHedge = i === index;
  }
  setValues({
    ...values,
    details,
    hedges
  });
};
const deleteHedge = (values, index, setValues) => {
  const hedges = values.hedges;
  hedges.splice(index, 1);
  setValues({
    ...values,
    hedges
  });
};

export const addHedgeRow = (quoteData, setValues) => {
  const loan = quoteData.details;
  const hedges = quoteData.hedges;
  hedges.push({
    loanId: loan.id,
    dealId: loan.deal.id,
    isLenderRequired: false,
    hedgeStatusId: HEDGE_STATUSES.WATCH,
    daycountId: ACTUAL_OVER_360
  });
  setValues({
    ...quoteData,
    hedges
  });
};

export const renderHedges = (values, setValues, setFieldValue) => {
  if (!values || !values.hedges || values.hedges.length === 0) {
    return getNoHedgeRow();
  }

  return values.hedges.map((item, index) => {
    switch (values.hedges[index].hedgeTypeId) {
      case HEDGE_TYPES.CAP:
        return getCapRow(index, values, setValues, setFieldValue);
      case HEDGE_TYPES.SWAP:
        return getSwapRow(index, values, setValues, setFieldValue);
      case HEDGE_TYPES.ANY_LENDER_APPROVED:
        return null;
      default:
        return getEmptyRow(index, values, setValues, setFieldValue);
    }
  });
};
